
import AddToCart from "../cart/add-to-cart.vue";
import CommonMenuItemPriceLabel from "../common/common-menu-item-price-label.vue";
import EllipcisedText from "../common/ellipcised-text.vue";
import emptyImage from "~/assets/images/emptyImage.svg";

export default {
  components: { AddToCart, CommonMenuItemPriceLabel, EllipcisedText },
  props: {
    menuItem: {
      type: Object,
      required: true
    },
    showAddToCartButton: {
      type: Boolean,
      default: false
    },
    showDescription: {
      type: Boolean,
      default: true
    },
    reverseDirection: {
      type: Boolean,
      default: false
    },
    sizeProp: {
      type: String,
      default: "144"
    }
  },
  data() {
    return {
      emptyImage
    };
  }
};
